const R = 6371

function coordsDistance (plotLatitude, plotLongitude, currentLatitude, currentLongitude) {
  let plotLatitudeRad = getRad(plotLatitude)
  let plotLongitudeRad = getRad(plotLongitude)
  let currentLatitudeRad = getRad(currentLatitude)
  let currentLongitudeRad = getRad(currentLongitude)

  /* Calcola il terzo lato del triangolo sferico */
  let d = Math.acos(Math.sin(plotLatitudeRad) * Math.sin(currentLatitudeRad) +
    Math.cos(plotLatitudeRad) * Math.cos(currentLatitudeRad) * Math.cos(fi(plotLongitudeRad, currentLongitudeRad)))
  /* Calcola la distanza sulla superficie terrestre in metri */
  let dist = d * R * 1000

  return dist.toFixed(2)
}

/* Converte i gradi in radianti */
function getRad (coord) {
  return ((Math.PI * coord) / 180)
}

/* Calcola l'angolo compreso fi */
function fi (plotLongitude, currentLongitude) {
  return Math.abs(plotLongitude - currentLongitude)
}

export default coordsDistance
